import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight, FileText, MessageCircle, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const OPTION_ICONS = [
  <FileText size={32} />,
  <MessageCircle size={32} />,
  <Users size={32} />,
]

const OPTION_PATHS = ['/solicite-cotacao', '/fale-conosco', '/trabalhe-conosco']
const OPTION_KEYS = ['quote', 'fale', 'trabalhe']

const Contact = () => {
  const { t } = useTranslation()

  const options = OPTION_KEYS.map((key, i) => ({
    icon: OPTION_ICONS[i],
    title: t(`contact.${key}.title`),
    description: t(`contact.${key}.desc`),
    path: OPTION_PATHS[i],
  }))

  return (
    <div
      className="min-h-screen relative flex flex-col"
      style={{
        backgroundImage: `url(${import.meta.env.BASE_URL}images/contato.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(to right, rgba(5,18,45,0.97) 0%, rgba(5,18,45,0.90) 40%, rgba(5,18,45,0.55) 70%, rgba(5,18,45,0.15) 100%)' }}
      />

      <div className="relative z-10 flex flex-col min-h-screen pt-28 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto w-full flex-1 flex flex-col items-center justify-center text-center">

          {/* Cabeçalho */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-14"
          >
            <h1 className="text-5xl md:text-6xl font-heading font-bold text-white leading-tight mb-6">
              {t('contact.title')} <span style={{ color: '#38bdf8' }}>{t('contact.titleHighlight')}</span>
            </h1>
            <p className="text-white/70 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
              {t('contact.subtitle')}
            </p>
          </motion.div>

          {/* 3 cards de opções */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-5xl">
            {options.map((opt, index) => (
              <motion.div
                key={opt.path}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 + index * 0.12 }}
              >
                <Link
                  to={opt.path}
                  className="group flex flex-col h-full rounded-2xl p-7 transition-all duration-300 hover:scale-[1.03]"
                  style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)' }}
                >
                  <div className="mb-5 flex justify-center" style={{ color: '#38bdf8' }}>
                    {React.cloneElement(opt.icon, { size: 36 })}
                  </div>
                  <h3 className="text-lg font-bold text-white mb-3">{opt.title}</h3>
                  <p className="text-white/65 text-sm leading-relaxed flex-1">{opt.description}</p>
                  <div className="mt-5 flex items-center justify-center gap-2 text-primary-400 text-sm font-semibold group-hover:gap-3 transition-all duration-200">
                    <span>{t('contact.access')}</span>
                    <ArrowRight size={16} />
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>

          {/* Barra inferior com contatos */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="mt-14 pt-6 border-t border-white/15 flex flex-wrap justify-center gap-8 text-white/60 text-sm w-full max-w-5xl"
          >
            <span className="flex items-center gap-2">📞 +55 11 3646-4000</span>
            <span className="flex items-center gap-2">✉️ contato@agsgloballogistics.com</span>
            <span className="flex items-center gap-2">🌐 www.agsgloballogistics.com.br</span>
          </motion.div>

        </div>
      </div>
    </div>
  )
}

export default Contact
